import { Col, Table } from "antd";
import Loading from "components/Common/Loading";
import { Link } from "react-router-dom";
import { ROUTES } from "../Constants";

const columns = [
    {
      title: "Vehicle Parts",
      dataIndex: "partType",
      key: "partType",
      className: "grey imei-text bold pl1",
      render: (_, record) =>
        ` ${
          record?.partType.slice(0, 1) +
          record?.partType.slice(1, record?.partType.length).toLowerCase()
        } ${record?.partType === "TYRE" ? " Pressure" : ""}`,
    },
    {
      title: "Health Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      className: "display-flex",
      render: (status) => <div style={statusClass(status)}>{status}</div>,
    },
];

const VehicleHealthWidget = ({ vehiclePartList, vehicleDetails }) =>{

    return(
        <>
        {!vehiclePartList?.length && <Loading/>}
        {vehiclePartList?.length && 

        <Col span={24} className="vehicle-part-table p0 mt1">
          <Table
            columns={columns}
            rowKey={(record) => record.partId}
            dataSource={vehiclePartList}
            pagination={false}
            showHeader={false}
            />
        </Col>
        }
        <Col className="mt105">
          <Link to={ROUTES.VEHICLE_HEALTH.link} state={{ vehicleDetails }}>
            <div className="view-more-link cursor-pointer flex-center">More</div>
          </Link>
        </Col>
        </>
    )
}

const statusClass = (status) => {
    const borderColor = {
      Excellent : '#06c802',
      Good: '#e8d209',
      Average: '#F07900',
      Poor: '#ff0000',
      Low: '#ff0000',
      High: '#ff0000',
      Normal: '#06c802'
  }

  return ({
    // color: '#ffffff',
    // background: `${borderColor[status]}`,
    border: `2px solid ${borderColor[status]}`,
    padding: '2px 10px',
    borderRadius: '10px',
    minWidth: '90px',
    maxWidth: '100px',
    textAlign: 'center',
  })
}

export default VehicleHealthWidget;